import { GAME_ID } from "@/stores";

export enum pageType {
  HOME = "社区首页",
  SEARCH = "搜索",
  POST = "发布页面",
  NOTICE = "消息中心",
  USER = "用户中心",
  POST_DETAIL = "帖子详情",
  REPLY_DETAIL = "回复详情",
  MENU = "导航",
  FANS = "粉丝",
  FOLLOW = "关注",
  AVATAR = "头像选择",
  NICKNAME_MODIFY = "修改昵称",
  NICKNAME_MODIFY_RECORD = "修改昵称记录",
  SHOP = "兑换中心页",
  EXCHANGE_RECORD = "兑换记录",
  SETTING = "设置",
  SELECT_BOARD = "选择版区",
  MAINTENANCE = "维护页面",
  PAGE = "单一页面",
  TOTAL = "总停留时间",
  FORUM = "论坛",
}
const routeNameMap = {
  home: pageType.HOME,
  notice: pageType.NOTICE,
  profile: pageType.USER,
  post: pageType.POST,
  postDetail: pageType.POST_DETAIL,
  replyDetail: pageType.REPLY_DETAIL,
  search: pageType.SEARCH,
  fans: pageType.FANS,
  user: pageType.USER,
  follow: pageType.FOLLOW,
  avatar: pageType.AVATAR,
  nicknameModify: pageType.NICKNAME_MODIFY,
  nicknameModifyRecord: pageType.NICKNAME_MODIFY_RECORD,
  shop: pageType.SHOP,
  exchangeRecord: pageType.EXCHANGE_RECORD,
  setting: pageType.SETTING,
  selectBoard: pageType.SELECT_BOARD,
  maintenance: pageType.MAINTENANCE,
  page: pageType.PAGE,
  forum: pageType.FORUM,
};

export const clickButton = (data) => {
  window.forumDataLayer.push({
    eventName: "click_button",
    eventType: data.eventType || "",
    eventReason: data.eventReason || "",
    eventValue: data.eventValue || "",
    gameId: GAME_ID,
    ...data,
  });
};

export const viewPage = (page, eventValue?: string) => {
  const data: any = {
    eventName: "view_page",
    eventType: routeNameMap[page] || page || "",
    gameId: GAME_ID,
  };
  if (eventValue) {
    data.eventValue = eventValue;
  }
  window.forumDataLayer.push(data);
};

export const viewPageTime = (page, time, eventReason?: string) => {
  // time为毫秒，需要转换为秒，取整
  time = Math.floor(time / 1000);
  const data: any = {
    eventName: "view_page_time",
    eventType: routeNameMap[page] || page || "",
    eventValue: time,
    gameId: GAME_ID,
  };
  if (eventReason) {
    data.eventReason = eventReason;
  }
  window.forumDataLayer.push(data);
};
